<section class="page">

  <!-- ==================================================
       HEADER
       ================================================== -->

  <header class="page-header">

    <div>

      <span class="eyebrow">
        Gestão de pedidos
      </span>

      <h1>
        Painel de pedidos
      </h1>

      <p>
        Organize o fluxo da cozinha e acompanhe os pedidos em tempo real.
      </p>

    </div>


    <div class="header-actions">

      <button
        type="button"
        class="refresh-button"
        [disabled]="loading"
        (click)="loadOrders()"
      >
        {{
          loading
            ? 'Atualizando...'
            : '↻ Atualizar'
        }}
      </button>


      <button
        type="button"
        class="sound-button"
        [class.active]="soundEnabled"
        (click)="enableSound()"
      >
        {{
          soundEnabled
            ? '🔊 Som ativado'
            : '🔇 Ativar som'
        }}
      </button>

    </div>

  </header>


  <!-- ==================================================
       FILTROS
       ================================================== -->

  <section class="filters-card">

    <!-- RESTAURANTE -->

    <div class="filter-group restaurant-filter">

      <label>
        Restaurante
      </label>

      <select
        [(ngModel)]="restaurantId"
        (change)="onRestaurantChange()"
      >

        <option
          *ngFor="
            let restaurant
            of restaurants
          "
          [value]="restaurant.id"
        >
          {{ restaurant.name }}
        </option>

      </select>

    </div>


    <!-- BUSCA -->

    <div class="filter-group">

      <label>
        Buscar pedido
      </label>

      <div class="search-wrapper">

        <span>
          🔎
        </span>

        <input
          type="text"
          inputmode="numeric"
          [(ngModel)]="searchOrderNumber"
          placeholder="Número do pedido"   (ngModelChange)="resetHistoryPage()"
        >

      </div>

    </div>


    <!-- STATUS -->

    <div class="filter-group">

      <label>
        Status
      </label>

      <select
        [(ngModel)]="statusFilter" (ngModelChange)="resetHistoryPage()"
      >

        <option value="ACTIVE">
          Pedidos ativos
        </option>

        <option value="ALL">
          Todos
        </option>

        <option value="PENDING">
          Pendentes
        </option>

        <option value="ACCEPTED">
          Aceitos
        </option>

        <option value="PREPARING">
          Em preparo
        </option>

        <option value="READY">
          Prontos
        </option>

        <option value="OUT_FOR_DELIVERY">
          Em entrega
        </option>

        <option value="DELIVERED">
          Entregues
        </option>

        <option value="CANCELED">
          Cancelados
        </option>

      </select>

    </div>


    <!-- TIPO -->

    <div class="filter-group">

      <label>
        Tipo
      </label>

      <select
        [(ngModel)]="deliveryTypeFilter"  (ngModelChange)="resetHistoryPage()"
      >

        <option value="ALL">
          Todos
        </option>

        <option value="DELIVERY">
          Entrega
        </option>

        <option value="PICKUP">
          Retirada
        </option>

        <option value="TABLE">
          Mesa
        </option>

      </select>

    </div>


    <!-- LIMPAR -->

    <button
      type="button"
      class="clear-filter-button"
      (click)="clearFilters()"
    >
      Limpar
    </button>


    <!-- TOTAL -->

    <div class="filter-summary">

      <strong>
        {{ filteredOrders.length }}
      </strong>

      <span>
        encontrado(s)
      </span>

    </div>

  </section>


  <!-- ==================================================
       LOADING
       ================================================== -->

  <div
    class="loading-state"
    *ngIf="
      loading &&
      !orders.length
    "
  >
    Carregando pedidos...
  </div>


  <!-- ==================================================
       KANBAN
       Somente pedidos operacionais
       ================================================== -->

  <section
    class="kanban"
    *ngIf="
      (!loading || orders.length) &&
      !showingHistory
    "
  >

    <section
      class="kanban-column"
      *ngFor="
        let column
        of columns
      "
      [attr.data-column]="column.key"
    >

      <!-- CABEÇALHO DA COLUNA -->

      <header class="column-header">

        <div>

          <div class="column-title">

            <span>
              {{ column.icon }}
            </span>

            <strong>
              {{ column.title }}
            </strong>

          </div>

          <small>
            {{ column.description }}
          </small>

        </div>


        <span class="column-count">
          {{
            columnCount(
              column.key
            )
          }}
        </span>

      </header>


      <!-- PEDIDOS -->

      <div class="column-orders">

        <article
          class="order-card"
          *ngFor="
            let order
            of ordersByColumn(
              column.key
            );
            trackBy: trackByOrderId
          "
          [attr.data-status]="order.status"
        >

          <!-- TOPO -->

          <header class="order-card-header">

            <div>

              <strong class="order-id">
                #{{ order.id }}
              </strong>

              <span class="order-time">
                {{
                  orderAgeLabel(
                    order
                  )
                }}
              </span>

            </div>


            <span
              class="age-badge"
              [attr.data-level]="
                ageLevel(order)
              "
            >

              ⏱

              {{
                orderAgeLabel(
                  order
                )
              }}

            </span>

          </header>


          <!-- STATUS -->

          <div class="status-line">

            <span
              class="status-badge"
              [attr.data-status]="order.status"
            >
              {{
                statusLabel(
                  order.status
                )
              }}
            </span>


            <span class="created-time">
              {{
                order.createdAt
                  | date:'HH:mm'
              }}
            </span>

          </div>


          <!-- CLIENTE -->

          <section class="customer-summary">

            <div class="customer-avatar">
              {{
                order.customerName
                  ?.charAt(0)
                  || 'C'
              }}
            </div>


            <div>

              <strong>
                {{ order.customerName }}
              </strong>

              <span>
                {{ order.customerPhone }}
              </span>

            </div>

          </section>


          <!-- RESUMO -->

          <section class="order-summary">

            <div>

              <span>
                📦
              </span>

              <strong>
                {{
                  totalItems(
                    order
                  )
                }}
                item(ns)
              </strong>

            </div>


            <div>

              <span>
                {{
                  order.deliveryType === 'DELIVERY'
                    ? '🛵'
                    : order.deliveryType === 'TABLE'
                      ? '🪑'
                      : '🥡'
                }}
              </span>

              <strong>
                {{
                  deliveryTypeLabel(
                    order.deliveryType
                  )
                }}
              </strong>

            </div>

          </section>


          <!-- MESA -->

          <div
            class="compact-detail"
            *ngIf="order.tableNumber"
          >

            <span>
              Mesa
            </span>

            <strong>
              {{ order.tableNumber }}
            </strong>

          </div>


          <!-- OBSERVAÇÃO -->

          <div
            class="note-alert"
            *ngIf="order.notes"
          >

            <span>
              ⚠
            </span>

            <div>

              <small>
                Observação
              </small>

              <strong>
                {{ order.notes }}
              </strong>

            </div>

          </div>


          <!-- VALOR -->

          <div class="compact-total">

            <span>
              Total
            </span>

            <strong>
              {{
                formatMoney(
                  order.total
                )
              }}
            </strong>

          </div>


          <!-- AÇÕES -->
<!-- AÇÕES -->

<div class="card-actions">

  <button
    type="button"
    class="details-button"
    (click)="toggleDetails(order)"
  >
    {{
      isExpanded(order)
        ? 'Ocultar detalhes'
        : 'Ver pedido'
    }}
  </button>

</div>


<!-- ALTERAÇÃO RÁPIDA DE STATUS -->

<div class="quick-status">

  <label>
    Status do pedido
  </label>

  <div class="quick-status-select">

    <select
      [ngModel]="order.status"
      [disabled]="isUpdating(order)"
      (ngModelChange)="updateStatus(order, $event)"
      [attr.data-status]="order.status"
    >

      <option
        *ngFor="let status of availableStatuses(order)"
        [value]="status"
      >
        {{ statusOptionLabel(status) }}
      </option>

    </select>

    <span
      class="status-loading"
      *ngIf="isUpdating(order)"
    >
      Atualizando...
    </span>

  </div>

</div>


          <!-- DETALHES EXPANDIDOS -->

          <section
            class="expanded-details"
            *ngIf="
              isExpanded(order)
            "
          >

            <div class="expanded-divider"></div>


            <!-- ENTREGA -->

            <div
              class="delivery-information"
              *ngIf="
                order.customerAddress ||
                order.tableNumber
              "
            >

              <div
                *ngIf="
                  order.customerAddress
                "
              >

                <span>
                  Endereço
                </span>

                <strong>
                  {{ order.customerAddress }}
                </strong>

              </div>


              <div
                *ngIf="
                  order.tableNumber
                "
              >

                <span>
                  Mesa
                </span>

                <strong>
                  {{ order.tableNumber }}
                </strong>

              </div>

            </div>


            <!-- ITENS -->

            <section class="order-items">

              <header>

                <strong>
                  Itens do pedido
                </strong>

                <span>
                  {{
                    totalItems(
                      order
                    )
                  }}
                  item(ns)
                </span>

              </header>


              <article
                class="order-item"
                *ngFor="
                  let item
                  of order.items
                "
              >

                <div class="item-quantity">
                  {{ item.quantity }}x
                </div>


                <div class="item-info">

                  <strong>
                    {{
                      item.product?.name
                      || 'Produto'
                    }}
                  </strong>


                  <small
                    *ngIf="
                      item.notes
                    "
                  >
                    {{ item.notes }}
                  </small>

                </div>


                <strong class="item-value">
                  {{
                    formatMoney(
                      item.total ||
                      Number(
                        item.unitPrice ||
                        item.product?.price
                      ) *
                      Number(
                        item.quantity
                      )
                    )
                  }}
                </strong>

              </article>

            </section>


            <!-- VALORES -->

            <section class="values">

              <div>

                <span>
                  Subtotal
                </span>

                <strong>
                  {{
                    formatMoney(
                      order.subtotal
                    )
                  }}
                </strong>

              </div>


              <div>

                <span>
                  Entrega
                </span>

                <strong>
                  {{
                    formatMoney(
                      order.deliveryFee
                    )
                  }}
                </strong>

              </div>


              <div class="final-value">

                <span>
                  Total
                </span>

                <strong>
                  {{
                    formatMoney(
                      order.total
                    )
                  }}
                </strong>

              </div>

            </section>


            <!-- STATUS MANUAL -->

            <div class="manual-status">

              <label>
                Alterar status manualmente
              </label>

              <select
                [ngModel]="order.status"
                (ngModelChange)="
                  updateStatus(
                    order,
                    $event
                  )
                "
              >

                <option
                  *ngFor="
                    let status
                    of statuses
                  "
                  [value]="status"
                >
                  {{
                    statusLabel(
                      status
                    )
                  }}
                </option>

              </select>

            </div>

          </section>

        </article>


        <!-- COLUNA VAZIA -->

        <div
          class="column-empty"
          *ngIf="
            !columnCount(
              column.key
            )
          "
        >

          <span>
            ✓
          </span>

          <strong>
            Nenhum pedido
          </strong>

          <small>
            Tudo tranquilo por aqui.
          </small>

        </div>

      </div>

    </section>

  </section>


  <!-- ==================================================
       HISTÓRICO
       ENTREGUES / CANCELADOS
       ================================================== -->

  <section
    class="history-section"
    *ngIf="
      showingHistory &&
      !loading
    "
  >

    <!-- CABEÇALHO -->

    <header class="history-header">

      <div>

        <span class="history-label">
          HISTÓRICO
        </span>

        <h2>
          {{
            statusFilter === 'DELIVERED'
              ? 'Pedidos entregues'
              : 'Pedidos cancelados'
          }}
        </h2>

        <p>
          Consulte pedidos que já saíram do fluxo operacional.
        </p>

      </div>


      <div class="history-total">

        <strong>
          {{ historyOrders.length }}
        </strong>

        <span>
          pedido(s)
        </span>

      </div>

    </header>


    <!-- LISTA -->

    <div
      class="history-list"
      *ngIf="
        historyOrders.length
      "
    >

      <article
        class="history-card"
         *ngFor="
    let order
    of paginatedHistoryOrders;
    trackBy: trackByOrderId
  "
      >

        <!-- PEDIDO / CLIENTE -->

        <div class="history-order-main">

          <div class="history-order-number">
            #{{ order.id }}
          </div>


          <div class="history-order-info">

            <strong>
              {{ order.customerName }}
            </strong>

            <span>
              {{
                order.createdAt
                  | date:'dd/MM/yyyy HH:mm'
              }}
            </span>

          </div>

        </div>


        <!-- TIPO -->

        <div class="history-detail">

          <span>
            Tipo
          </span>

          <strong>
            {{
              deliveryTypeLabel(
                order.deliveryType
              )
            }}
          </strong>

        </div>


        <!-- ITENS -->

        <div class="history-detail">

          <span>
            Itens
          </span>

          <strong>
            {{
              totalItems(
                order
              )
            }}
          </strong>

        </div>


        <!-- TOTAL -->

        <div class="history-detail">

          <span>
            Total
          </span>

          <strong class="history-value">
            {{
              formatMoney(
                order.total
              )
            }}
          </strong>

        </div>


        <!-- STATUS -->

        <div>

          <span
            class="status-badge"
            [attr.data-status]="order.status"
          >
            {{
              statusLabel(
                order.status
              )
            }}
          </span>

        </div>


        <!-- DETALHES -->

        <button
          type="button"
          class="history-details-button"
          (click)="
            toggleDetails(
              order
            )
          "
        >
          {{
            isExpanded(order)
              ? 'Fechar'
              : 'Ver pedido'
          }}
        </button>


        <!-- ==========================================
             DETALHES DO PEDIDO DO HISTÓRICO
             ========================================== -->

        <section
          class="history-expanded"
          *ngIf="
            isExpanded(order)
          "
        >

          <!-- ENDEREÇO -->

          <div
            class="history-address"
            *ngIf="
              order.customerAddress
            "
          >

            <span>
              Endereço
            </span>

            <strong>
              {{ order.customerAddress }}
            </strong>

          </div>


          <!-- MESA -->

          <div
            class="history-address"
            *ngIf="
              order.tableNumber
            "
          >

            <span>
              Mesa
            </span>

            <strong>
              {{ order.tableNumber }}
            </strong>

          </div>


          <!-- OBSERVAÇÃO -->

          <div
            class="history-address"
            *ngIf="
              order.notes
            "
          >

            <span>
              Observação
            </span>

            <strong>
              {{ order.notes }}
            </strong>

          </div>


          <!-- ITENS -->

          <div class="history-items">

            <div
              class="history-item"
              *ngFor="
                let item
                of order.items
              "
            >

              <strong>
                {{ item.quantity }}x
              </strong>

              <span>
                {{
                  item.product?.name
                  || 'Produto'
                }}
              </span>

              <b>
                {{
                  formatMoney(
                    item.total ||
                    Number(
                      item.unitPrice ||
                      item.product?.price
                    ) *
                    Number(
                      item.quantity
                    )
                  )
                }}
              </b>

            </div>

          </div>


          <!-- VALORES -->

          <section class="values">

            <div>

              <span>
                Subtotal
              </span>

              <strong>
                {{
                  formatMoney(
                    order.subtotal
                  )
                }}
              </strong>

            </div>


            <div>

              <span>
                Taxa de entrega
              </span>

              <strong>
                {{
                  formatMoney(
                    order.deliveryFee
                  )
                }}
              </strong>

            </div>


            <div class="final-value">

              <span>
                Total
              </span>

              <strong>
                {{
                  formatMoney(
                    order.total
                  )
                }}
              </strong>

            </div>

          </section>

        </section>

      </article>

    </div>






<!-- ==================================================
     PAGINAÇÃO DO HISTÓRICO
     ================================================== -->

<div
  class="history-pagination"
  *ngIf="historyOrders.length"
>

  <!-- INFORMAÇÃO -->

  <div class="pagination-info">

    Mostrando

    <strong>
      {{ historyStartItem }}
    </strong>

    até

    <strong>
      {{ historyEndItem }}
    </strong>

    de

    <strong>
      {{ historyOrders.length }}
    </strong>

    pedidos

  </div>


  <!-- CONTROLES -->

  <div class="pagination-controls">

    <button
      type="button"
      class="pagination-arrow"
      [disabled]="historyPage === 1"
      (click)="previousHistoryPage()"
      title="Página anterior"
    >
      ‹
    </button>


    <button
      type="button"
      class="pagination-page"
      *ngFor="
        let page
        of historyPages
      "
      [class.active]="
        historyPage === page
      "
      (click)="
        goToHistoryPage(page)
      "
    >
      {{ page }}
    </button>


    <button
      type="button"
      class="pagination-arrow"
      [disabled]="
        historyPage ===
        historyTotalPages
      "
      (click)="nextHistoryPage()"
      title="Próxima página"
    >
      ›
    </button>

  </div>


  <!-- PÁGINA ATUAL -->

  <div class="pagination-current">

    Página

    <strong>
      {{ historyPage }}
    </strong>

    de

    <strong>
      {{ historyTotalPages }}
    </strong>

  </div>

</div>












    <!-- HISTÓRICO VAZIO -->

    <div
      class="history-empty"
      *ngIf="
        !historyOrders.length
      "
    >

      <span>
        🧾
      </span>

      <strong>
        Nenhum pedido encontrado
      </strong>

    </div>

  </section>


  <!-- ==================================================
       NENHUM PEDIDO
       Para filtros do Kanban
       ================================================== -->

  <section
    class="empty-state"
    *ngIf="
      !loading &&
      !showingHistory &&
      !filteredOrders.length
    "
  >

    <div class="empty-icon">
      🧾
    </div>

    <h2>
      Nenhum pedido encontrado
    </h2>

    <p>
      Tente alterar os filtros ou aguarde um novo pedido.
    </p>

  </section>

</section>